import React from 'react';
import FeatureCard from '../../components/feature/FeatureCard';
import Banner from '../banner';
import { isBlank } from '../../utils/BooleanUtility';
import RoutineActivityList from '../../components/Routines/RoutineDetails/RoutineActivityList';

const Components = {
  feature: FeatureCard,
  banner: Banner,
  list: RoutineActivityList,
};

export default function RoutineCommonActivities(props) {
  const { activityType = '', itemData = {}, myRewardPoints = '', isRoutineActive } = props;
  if (isBlank(activityType)) return null;
  const LayoutComponent = Components[activityType?.toLowerCase()];
  if (LayoutComponent === undefined) return null;
  return <LayoutComponent itemData={itemData} myRewardPoints={myRewardPoints} isRoutineActive={isRoutineActive}/>;
}
